import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

/**
 * Componente para el modal de politica de datos
 */
@Component({
  standalone: false,
  selector: 'app-modal-polity',
  templateUrl: './modal-polity.component.html',
  styleUrls: ['./modal-polity.component.scss']
})
export class ModalPolityComponent implements OnInit {

  /**
   * Guarda si se muestran los botones de aceptar y cancelar
   */
  showButton: boolean;
  /**
   * Guarda si estamos en contratación
   */
  contratacion: boolean;
  /**
   * Variable para maquetación en mobile
   */
  showHeaderFooter: boolean;
  /**
   * Guarda si venimos del login
   */
  login: boolean;
  country: string;

  /**
   * Crea una instancia para modal polity component.
   * @param r 
   */
  constructor(private readonly r: Router,
    private route: ActivatedRoute
  ) { }

  /**
   * on init - setea las variables publicas antes declaradas
   */
  ngOnInit() {
    this.country = this.route.snapshot.paramMap.get('country') || 'ES';
    this.login = JSON.parse(sessionStorage.getItem('login_polity'));
    this.contratacion = !!JSON.parse(sessionStorage.getItem('getParams'));
    this.showButton = sessionStorage.getItem('polity') ? false : true;
    const getParams = JSON.parse(sessionStorage.getItem('getParams'));
    if (getParams) {
      this.showHeaderFooter = getParams[0] !== '3';
    } else {
      this.showHeaderFooter = true;
    }
    this.isExist();
  }

  /**
   * Redirige a la página anterior según la propiedad del storage
   */
  backView = () => {
    this.deleteTermsAndPolity();
    if (this.isExist() && !sessionStorage.getItem('signinSCF')) {
      this.r.navigateByUrl('/signin');
    } else if (!this.isExist() && !sessionStorage.getItem('signinSCF')) {
      window.history.back();
    } else if (sessionStorage.getItem('signinSCF')) {
      this.r.navigateByUrl('/terms?scf=true');
    }
  }

  /**
   * borra las variables de sesion
   */
  deleteTermsAndPolity = () => {
    sessionStorage.removeItem('polity');
    sessionStorage.removeItem('terms');
  }

  /**
   * Acepta la politica de datos y redirige 
   */
  agreePolity() {
    sessionStorage.setItem('polity', '1');
    sessionStorage.getItem('form_sign');
    this.isEngagement();
    if (this.isExist() && !sessionStorage.getItem('signinSCF')) {
      this.r.navigateByUrl('/signin');
    } else if (!this.isExist() && !sessionStorage.getItem('signinSCF')) {
      this.r.navigateByUrl('/terms');
    } else if (sessionStorage.getItem('signinSCF')) {
      this.r.navigateByUrl('/terms?scf=true');
    }

  }


  isExist = () => {
    return sessionStorage.getItem('form_sign') || sessionStorage.getItem('form_sign') === 'undefined' || sessionStorage.getItem('form_sign') === 'null';
  }


  goToUrl(url) {
    this.r.navigateByUrl(url);
  }

  isEngagement() {
    const aux = sessionStorage.getItem('getParams');
    const getParams = JSON.parse(aux);
    if (getParams) {
      sessionStorage.setItem('auxParam', aux);
    }
  }
}
